const Button = (props) => {
    return (
        <button className={props.className} type={props.type} id={props.id}>
            {(props?.isLoading === true) ? (<i className="fa fa-spinner fa-spin"></i>) : ("")}  {props.buttonName} {(props?.btnIcon === true) ? (<i className="fa fa-arrow-right" aria-hidden="true"></i>) : ("")}
        </button>
    );
};

export default Button;
